import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../../../data/demoProducts";
import { API_URL } from "../../../config";
import { useSiteAssets, optimized } from "../../../siteAssets";
import male from "../../../assets/male.png";
import female from "../../../assets/female.png";
import styles from "./styles.module.css";

const GENDER_TILES = [
  { label: "Shop Men", to: "/shop?gender=Men", image: male, slot: "shopby-men" },
  { label: "Shop Women", to: "/shop?gender=Women", image: female, slot: "shopby-women" },
];

const ShopBy = () => {
  const assets = useSiteAssets();
  // Chips reflect the real store categories; demo taxonomy is the fallback
  const [categories, setCategories] = useState(CATEGORIES);

  useEffect(() => {
    fetch(`${API_URL}/categories`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => {
        if (Array.isArray(list) && list.length) {
          setCategories(list.map((c) => c.name));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className={styles.wrap}>
      <div className={styles.head}>
        <p className={styles.eyebrow}>Shop by</p>
        <h2 className={styles.title}>Find your fit</h2>
      </div>

      <div className={styles.genders}>
        {GENDER_TILES.map((tile) => (
          <Link
            key={tile.to}
            to={tile.to}
            className={styles.tile}
            style={{
              backgroundImage: `linear-gradient(to top, rgba(15,13,11,0.55), rgba(15,13,11,0.05)), url(${
                assets[tile.slot] ? optimized(assets[tile.slot]) : tile.image
              })`,
            }}
          >
            <span className={styles.tileLabel}>{tile.label}</span>
            <span className={styles.tileArrow} aria-hidden="true">→</span>
          </Link>
        ))}
      </div>

      <div className={styles.cats}>
        <span className={styles.catsLabel}>Shop by type</span>
        <div className={styles.chips}>
          {categories.map((category) => (
            <Link
              key={category}
              to={`/shop?category=${encodeURIComponent(category)}`}
              className={styles.chip}
            >
              {category}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopBy;
